module.exports = __webpack_public_path__ + "img/piece-complete-2.e724ad5a.svg";